import _ from 'lodash';
import template from './email-notification-template-update.html';

const UNLIMITED = -1;
const mapStateToThis = ({ session }) => {
  const { locale } = session;

  return {
    locale,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'gettextCatalog', 'Notifications')
class EmailNotificationsTemplateUpdateController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
    this.formModel = null;
    this.loaded = false;
  }

  $onInit(templatesKey = 'template') {
    this.onLanguageSelect(this.locale);
    this.validationRules = this.api.config.validationRules.emailNotificationTemplate;
    this.templateId = parseInt(this.$state.params.templateId, 10);
    this.templateName = this.$state.params.templateName;
    if (this.templateId) {
      this.api.fetchTemplate.run(this.templateId).then((model) => {
        this.formModel = _.clone(model.notificationTemplates[templatesKey][this.templateId] || null);
        this.loaded = true;
      });
    }
  }

  $postLink() {
    this.api.initializeForm.run(this.namespace, this.moduleName, this.form);
  }

  submitForm() {
    this.api.validateForm.run(this.namespace, this.moduleName).then(() => {
      this.api.updateTemplate
        .run(this.templateId, this.formModel)
        .then(() => this.Notifications.alertSuccess(this.gettextCatalog.getString('Template saved successfully')))
        .then(() =>
          this.$state.go('emailNotificationsTemplates-view', {
            tabId: this.activeTabId,
            skipDirtyForms: true,
          })
        );
    });
  }

  prepareOptions() {
    return {
      ...this.api.config.ckeditor,
      extraPlugins: 'autogrow,emailVariables,wordcount,notification',
      emailVariables: this.formModel.params,
      wordcount: {
        showParagraphs: false,
        showWordCount: false,
        showCharCount: true,
        countSpacesAsChars: true,
        countHTML: true,
        maxWordCount: UNLIMITED,
        maxCharCount: this.api.config.validationRules.emailNotificationTemplate.body.length,
      },
    };
  }

  onLanguageSelect(locale) {
    this.model[this.namespace][this.moduleName].language = locale;
  }
}

export { EmailNotificationsTemplateUpdateController };

export default class EmailNotificationsTemplateUpdateComponent {
  constructor() {
    this.template = template;
    this.controller = EmailNotificationsTemplateUpdateController;
    this.bindings = {
      appCtrl: '<',
      model: '<',
      namespace: '@',
      moduleName: '@',
      api: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/email-notification-templates/components/update/email-notification-template-update-component.js